(function () {

  'use strict';

  angular.module('PrintixProviderUser', [])

    .constant('RequiredUserModelProperties', [
      '_embedded',
      '_embedded.user',
      '_embedded.user.name',
      '_embedded.user.email',
      '_embedded.permissions',
      '_embedded.permissions.role'
    ])

    .constant('UserEmbeddedPropertiesAdmin', '?embed=invites,groups')

    .constant('UserEmbeddedProperties', '?embed=invites,groups')

    .factory('UserModel', function ($rootScope, Utils, $filter, PrintixUserInfoConstants, PrinterListService,
      RequiredUserModelProperties, $http, $q, USER_RIGHTS, TenantListService, $injector, $log) {
      return function (userDataReceived, sites) {

        const UserModelPrivate = {};

        const UserModel = {
          permissions: formatPermissions(userDataReceived._embedded.permissions),
          sites: sites ? formatSites(sites) : null,
          networks: sites ? formatNetworks(sites) : [],
          signInMethods: formatSignInMethods(userDataReceived._embedded.user.authenticationMethods)
        };
        UserModel.siteFilter = configureSiteFiltering(UserModel.sites);

        let WorkstationModel = null;
        try {
          WorkstationModel = $injector.get('WorkstationModel');
        } catch (e) {}

        function formatSignInMethods(authenticationMethods) {
          const signInMethodSet = {};
          if (authenticationMethods) {
            authenticationMethods.forEach((signInMethod) => {
              signInMethodSet[signInMethod] = signInMethod;
            });
          }
          return signInMethodSet;
        }

        function configureSiteFiltering(sites) {
          return {
            sites: sites ? sites.map(site => site._links.self.href.split('/').pop()) : [],
            applySiteFilter: !UserModel.permissions.TENANT_ADMIN
          };
        }

        function formatPermissions(permissions) {
          const permissionSet = {};
          angular.forEach(permissions.permissions, function (permission) {
            permissionSet[permission] = true;
          });
          return permissionSet;
        }

        function formatSites(sites) {
          const siteResources = [];
          if (sites._embedded) {
            angular.forEach(sites._embedded.siteResources, function (site) {
              site._links['px:network'] = formatSiteNetwork(site);
              siteResources.push(site);
            });
          } else if (angular.isArray(sites)) {
            angular.forEach(sites, function (site) {
              site._links = angular.copy(site.links);
              site._links['px:network'] = formatSiteNetwork(site);
              siteResources.push(site);
            });
          }
          return siteResources;
        }

        function formatSiteNetwork(site) {
          if (!site._links['px:network']) {
            return [];
          }
          if (angular.isArray(site._links['px:network'])) {
            return site._links['px:network'];
          }
          if (site._links['px:network'].href) {
            return [{
              href: site._links['px:network'].href
            }];
          }
        }

        function formatNetworks(sites) {
          const networks = [];
          if (sites._embedded) {
            angular.forEach(sites._embedded.siteResources, function (site) {
              site._links['px:network'] = formatSiteNetwork(site);
              angular.forEach(site._links['px:network'], function (network) {
                networks.push(network.href);
              });
            });
          } else if (angular.isArray(sites)) {
            angular.forEach(sites, function (site) {
              site._links['px:network'] = formatSiteNetwork(site);
              angular.forEach(site._links['px:network'], function (network) {
                networks.push(network.href);
              });
            });
          }
          return networks;
        }

        UserModel.init = function (userDataReceived) {
          if (Utils.objectPropertiesCheck(userDataReceived, RequiredUserModelProperties)) {
            UserModel.info = angular.copy(userDataReceived);
            UserModel.options = {
              isSelected: false
            };
            UserModel.customProperties = {};
            UserModelPrivate.normalizeLinks();
            UserModelPrivate.guestUserExpirationDate(userDataReceived);
          } else {
            throw new Error('UserModel: userDataReceived is not valid');
          }
        };

        UserModel.isThisSiteMine = function (siteUrl) {
          return (UserModel.permissions.TENANT_ADMIN && !UserModel.isSystemObserver()) ||
            !!(siteUrl && UserModel.sites.find(site => site._links.self.href === siteUrl));
        };

        UserModelPrivate.guestUserExpirationDate = function (userDataReceived) {
          if (userDataReceived._embedded.permissions.role === 'GUEST_USER') {
            const expiryDate = new Date(userDataReceived._embedded.permissions.expirationTime);
            UserModel.customProperties.expirationDate = expiryDate.getTime();
          }
        };

        UserModelPrivate.normalizeLinks = function () {
          angular.forEach(UserModel.info._links, function (link, index) {
            if (angular.isObject(link) && !angular.isArray(link)) {
              const linkClean = link.href.split('?')[0];
              UserModel.info._links[index].href = linkClean;
            }
          });
          const selfHrefSplit = UserModel.info._links.self.href.split('/');
          UserModel.customProperties.id = selfHrefSplit[selfHrefSplit.length - 1];
        };

        UserModel.replaceInfo = function (embeddedKey, data, doNotReplaceEmbeddedAndLinks) {
          if (!UserModel.info._embedded) {
            UserModel.info._embedded = {};
          }
          if (embeddedKey) {
            UserModel.info._embedded[embeddedKey] = angular.copy(data);
          } else {
            const embedded = angular.copy(UserModel.info._embedded);
            const links = angular.copy(UserModel.info._links);
            UserModel.info = angular.copy(data);
            if (!doNotReplaceEmbeddedAndLinks) {
              UserModel.info._embedded = embedded;
              UserModel.info._links = links;
            }
            UserModelPrivate.normalizeLinks();
          }
        };

        UserModel.showInfo = function () {
          UserModel.getLoggedInWorkstations()
            .then(function () {
              $rootScope.$emit(PrintixUserInfoConstants.SHOW, UserModel);
            })
            .catch(function () {
            }); ;
        };

        UserModel.getLoggedInWorkstations = function () {
          if (WorkstationModel) {
            UserModel.customProperties.workstationList = [];
            const userSuffix = '?user=' + UserModel.info._links.self.href;
            const deferred = $q.defer();
            $http.get(TenantListService.currentTenant.info._links['px:workstations'].href + userSuffix)
              .then(function (response) {
                if (response?.data) {
                  if (response.data._embedded?.workstations) {
                    const workstationList = angular.forEach(response.data._embedded.workstations, function (workstation) {
                      UserModel.customProperties.workstationList.add(new WorkstationModel(workstation));
                    });
                    deferred.resolve(workstationList);
                  } else {
                    deferred.resolve();
                  }
                } else {
                  deferred.reject();
                }
              })
              .catch(function (error) {
                deferred.reject(error);
              });
            return deferred.promise;
          } else {
            throw new Error('UserModel.getLoggedInWorkstations: WorkstationModel is missing');
          }
        };

        UserModel.changeRole = function (userChanged) {
          if (userChanged) {
            const dataToSend = [{
              op: 'replace',
              path: '/role',
              value: userChanged.info._embedded.permissions.role
            }];
            const deferred = $q.defer();
            $http.patch(UserModel.info._embedded.permissions._links.self.href, dataToSend)
              .then(function (response) {
                UserModel.info._embedded.permissions = response.data;
                if ([UserModel].findElement({ info: { _links: { self: { href: $rootScope.currentUser.info._links.self.href } } } })) {
                  $rootScope.signOut();
                }
                deferred.resolve(response);
              })
              .catch(function (error) {
                deferred.reject(error);
              });
            return deferred.promise;
          } else {
            throw new Error('UserModel.changeRole: userChanged is missing');
          }
        };

        UserModel.synchronizeGroups = function () {
          const deferred = $q.defer();
          if (UserModel.info._links['px:groupSynchronization']) {
            $http.post(UserModel.info._links['px:groupSynchronization'].href)
              .then(function (response) {
                deferred.resolve(response);
              })
              .catch(function (error) {
                deferred.reject(error);
              });
          } else {
            $log.warn('px:synchronizeGroups link is missing for this user...');
            deferred.reject();
          }
          return deferred.promise;
        };

        UserModel.showChangeLogNotification = function () {
          if (TenantListService.currentTenant.info?.createdTime) {
            const tenantRegistrationDate = new Date(TenantListService.currentTenant.info.createdTime).getTime();
            const lastLogDate = new Date($filter('translate')('CHANGE_LOG_LATEST_TIMESTAMP')).getTime();
            if (tenantRegistrationDate < lastLogDate) {
              if (UserModel.info.userAppSettings?.changeLogReviewDate) {
                const userLastSeenLogDate = new Date(UserModel.info.userAppSettings.changeLogReviewDate).getTime();
                return userLastSeenLogDate < lastLogDate;
              } else {
                return true;
              }
            } else {
              return false;
            }
          } else {
            return true;
          }
        };

        UserModel.hideChangeLogNotification = function () {
          const lastChangeLogDate = $filter('translate')('CHANGE_LOG_LATEST_TIMESTAMP');
          let objectToSend = {
            op: 'replace',
            path: '/userAppSettings/changeLogReviewDate',
            value: lastChangeLogDate
          };
          if (!UserModel.info.userAppSettings) {
            objectToSend = {
              op: 'add',
              path: '/userAppSettings',
              value: {
                changeLogReviewDate: lastChangeLogDate
              }
            };
          } else {
            if (!UserModel.info.userAppSettings.changeLogReviewDate) {
              objectToSend.op = 'add';
            }
          }
          const deferred = $q.defer();
          $http.patch(UserModel.info._links.self.href, [objectToSend])
            .then(function (response) {
              UserModel.info.userAppSettings = response.data.userAppSettings;
              deferred.resolve(response);
            })
            .catch(function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        };

        UserModel.saveChanges = function (userChanged) {
          if (userChanged) {
            const patchObjectArray = Utils.getObjectsDifferencesForPatching(UserModel.info, userChanged.info);
            if ((patchObjectArray && patchObjectArray.length > 0) || userChanged.info._embedded.permissions.role !== UserModel.info._embedded.permissions.role) {
              const deferred = $q.defer();
              if (userChanged.info._embedded.permissions.role !== UserModel.info._embedded.permissions.role) {
                patchObjectArray.removeWith({
                  path: '/_embedded/permissions/role'
                });
                // if the role is changed - save it first and then apply the other changes if any
                UserModel.changeRole(userChanged)
                  .then(function (response) {
                    if (patchObjectArray && patchObjectArray.length > 0) {
                      $http.patch(UserModel.info._links.self.href, patchObjectArray)
                        .then(function (response2) {
                          UserModel.replaceInfo(null, response2.data);
                          deferred.resolve(response2);
                        })
                        .catch(function () {
                        });
                    } else {
                      deferred.resolve(response);
                    }
                  })
                  .catch(function (error) {
                    deferred.reject(error);
                  });
              } else {
                // if the role is NOT changed - then apply the other changes
                $http.patch(UserModel.info._links.self.href, patchObjectArray)
                  .then(function (response) {
                    UserModel.replaceInfo(null, response.data);
                    deferred.resolve(response);
                  })
                  .catch(function (error) {
                    deferred.reject(error);
                  });
              }
              return deferred.promise;
            } else {
              return $q.resolve();
            }
          } else {
            throw new Error('UserModel.saveChanges: userChanged is missing');
          }
        };

        UserModel.hasPermission = function (permission) {
          return UserModel.info._embedded.permissions.permissions.includes(permission);
        };

        UserModel.hasSomePermission = function (permissions) {
          const userPermissions = UserModel.info._embedded.permissions.permissions;
          return permissions.some(permission => userPermissions.includes(permission));
        };

        UserModel.hasEveryPermission = function (permissions) {
          const userPermissions = UserModel.info._embedded.permissions.permissions;
          return permissions.every(permission => userPermissions.includes(permission));
        };

        UserModel.hasSitePermission = function (permission) {
          return UserModel.info._embedded.permissions.sitePermissions.includes(permission);
        };

        UserModel.hasSomeSitePermission = function (permissions) {
          const userSitePermissions = UserModel.info._embedded.permissions.sitePermissions;
          return permissions.some(permission => userSitePermissions.includes(permission));
        };

        UserModel.hasEverySitePermission = function (permissions) {
          const userSitePermissions = UserModel.info._embedded.permissions.sitePermissions;
          return permissions.every(permission => userSitePermissions.includes(permission));
        };

        UserModel.hasPrimaryRole = function (role) {
          return UserModel.info._embedded.permissions.role === role;
        };

        UserModel.hasSomePrimaryRole = function (roles) {
          const userRole = UserModel.info._embedded.permissions.role;
          return roles.some(role => userRole === role);
        };

        UserModel.hasSecondaryRole = function (role) {
          return UserModel.info._embedded.permissions.roles.includes(role);
        };

        UserModel.isSystemManager = function () {
          return UserModel.hasPrimaryRole('SYSTEM_MANAGER');
        };

        UserModel.isSystemObserver = function () {
          return UserModel.hasPrimaryRole('SYSTEM_OBSERVER');
        };

        UserModel.isSiteManager = function () {
          return UserModel.hasSecondaryRole('SITE_MANAGER');
        };

        UserModel.init(userDataReceived);
        delete UserModel.init;

        return UserModel;
      };
    })

    .factory('UserListPaging', function ($rootScope, Utils, $filter, PrintixUserInfoConstants, PrinterListService,
      RequiredUserModelProperties, $http, $q, USER_RIGHTS, TenantListService, $injector, DEFAULT_ITEMS_PER_PAGE) {
      return function (userDataReceived) {

        const UserListPaging = {};

        UserListPaging.pagingCriteria = {
          page: 0,
          pageSize: DEFAULT_ITEMS_PER_PAGE,
          direction: 'ASC',
          match: null,
          sort: 'NAME',
          embed: null,
          userIdString: null,
          roles: null,
          groups: null
        };

        UserListPaging.getPagedUrlParameters = function () {
          let urlParameters =
              '?page=' + UserListPaging.pagingCriteria.page +
              '&pageSize=' + UserListPaging.pagingCriteria.pageSize +
              '&direction=' + UserListPaging.pagingCriteria.direction +
              '&sort=' + UserListPaging.pagingCriteria.sort +
              '&embed=invites,groups';
          if (UserListPaging.pagingCriteria.roles) {
            urlParameters += '&roles=' + UserListPaging.pagingCriteria.roles;
          }
          if (UserListPaging.pagingCriteria.match) {
            urlParameters += '&match=' + UserListPaging.pagingCriteria.match;
          }
          if (UserListPaging.pagingCriteria.groups) {
            urlParameters += '&groups=' + UserListPaging.pagingCriteria.groups;
          }
          return urlParameters;
        };

        return UserListPaging;

      };
    })

    .service('UserListService', function ($rootScope, UserModel, $filter, Utils, TenantListService, $timeout, USER_ROLES, EventServiceEvents,
      $http, $q, $injector, USER_RIGHTS, UserEmbeddedPropertiesAdmin, UserEmbeddedProperties, SitesProviderService) {

      const UsersListModelPrivate = {};
      const userListServiceAsObject = this;
      let getUsersListUrlSuffix = '';

      try {
        $injector.get('APIAdmin');
        getUsersListUrlSuffix = UserEmbeddedPropertiesAdmin;
      } catch (e) {
        getUsersListUrlSuffix = UserEmbeddedProperties;
      }

      UsersListModelPrivate.getCurrentUser = function () {
        if (TenantListService.currentTenant.info._links['px:currentuser']) {
          userListServiceAsObject.resolveCurrentUser();
        } else {
          $rootScope.signOut();
        }
      };

      function getUserSites(user) {
        const deferred = $q.defer();
        $http.get(user._links['px:sites'].href)
          .then(function (sitesResponse) {
            deferred.resolve(sitesResponse.data);
          })
          .catch(function (error) {
            deferred.reject(error);
          });
        return deferred.promise;
      }

      UsersListModelPrivate.createUserInvite = function (userInvite) {
        if (userInvite) {
          userInvite._embedded = {
            user: {
              name: null,
              email: userInvite.email,
              language: userInvite.language
            },
            permissions: {
              role: USER_ROLES[userInvite.role]
            }
          };
          return new UserModel(userInvite);
        } else {
          throw new Error('UsersListModelPrivate.createUserInvite: userInvite is missing');
        }
      };

      UsersListModelPrivate.getInvite = function (url) {
        if (url) {
          const deferred = $q.defer();
          $http.get(url)
            .then(function (response) {
              deferred.resolve(UsersListModelPrivate.createUserInvite(response.data));
            })
            .catch(function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        } else {
          throw new Error('UsersListModelPrivate.getInvite: url is missing');
        }
      };

      // Call this function only after TenantListService.currentTenant is set.
      this.resolveCurrentUser = function () {
        if (!userListServiceAsObject.currentUserPromise) {
          const deferred = $q.defer();
          $http.get(TenantListService.currentTenant.info._links['px:currentuser'].href)
            .then(function (response) {
              const user = response.data;
              getUserSites(user)
                .then(function (sites) {
                  $rootScope.currentUser = new UserModel(user, sites);
                  deferred.resolve($rootScope.currentUser);
                })
                .catch(function (error) {
                  userListServiceAsObject.currentUserPromise = undefined;
                  deferred.reject(error);
                });
            })
            .catch(function (error) {
              userListServiceAsObject.currentUserPromise = undefined;
              deferred.reject(error);
            });
          userListServiceAsObject.currentUserPromise = deferred.promise;
        }
        return userListServiceAsObject.currentUserPromise;
      };

      this.getCurrentUser = function () {
        return userListServiceAsObject.resolveCurrentUser();
      };

      this.getUserById = function (userId) {
        if (userId) {
          const deferred = $q.defer();
          $http.get(TenantListService.currentTenant.info._links['px:tenantusers'].href + '/' + userId + getUsersListUrlSuffix)
            .then(function (response) {
              if (response?.data) {
                deferred.resolve(new UserModel(response.data));
              } else {
                deferred.reject(response);
              }
            })
            .catch(function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        } else {
          throw new Error('UserListService.getUserById: userId is missing');
        }
      };

      this.createUser = function (data) {
        if (data && TenantListService.currentTenant) {
          data.tenantId = TenantListService.currentTenant.info._links.self.href;
          const deferred = $q.defer();
          $http.post(TenantListService.currentTenant.info._links['px:invites'].href, data)
            .then(function (response) {
              deferred.resolve(UsersListModelPrivate.createUserInvite(response.data));
            })
            .catch(function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        } else {
          throw new Error('UserListService.createUser: data or TenantListService.currentTenant are missing');
        }
      };

      this.deleteUser = function (user) {
        if (user) {
          const deferred = $q.defer();
          $http.delete(user.info._links.self.href)
            .then(function () {
              deferred.resolve();
            })
            .catch(function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        } else {
          throw new Error('UserListService.deleteUser: user is missing');
        }
      };

      this.deleteSelectedUsers = function (userList, callback) {
        if (userList?.length) {
          angular.forEach(userList, function (user) {
            userListServiceAsObject.deleteUser(user);
          });
          if (callback) {
            callback();
          }
        } else {
          throw new Error('UserListService.deleteSelectedUsers: userList is missing or it`s length is less than 1');
        }
      };

      this.getUserListPaged = function functionName(userListPaging) {
        if (userListPaging && TenantListService.currentTenant?.info) {
          const deferred = $q.defer();
          $http.get(TenantListService.currentTenant.info._links['px:tenantusers'].href + userListPaging.getPagedUrlParameters())
            .then(function (response) {
              const userListObject = {
                page: response.data.page,
                _links: response.data._links,
                list: []
              };
              if (response.data?._embedded?.['px:tenantUserResources']) {
                angular.forEach(response.data._embedded['px:tenantUserResources'], function (userData) {
                  userListObject.list.add(new UserModel(userData));
                });
              }
              if (response.data?._embedded?.['px:inviteResources']) {
                angular.forEach(response.data._embedded['px:inviteResources'], function (inviteData) {
                  userListObject.list.add(UsersListModelPrivate.createUserInvite(inviteData));
                });
              }
              deferred.resolve(userListObject);
            })
            .catch(function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        } else {
          throw new Error('UserListService.getUserListPaged: userListService or TenantListService.currentTenant or TenantListService.currentTenant.info are missing');
        }
      };

      const deregisterWatchCurrentTenant = $rootScope.$watch(function () {
        return TenantListService.currentTenant;
      }, function () {
        if (TenantListService.currentTenant) {
          UsersListModelPrivate.getCurrentUser();
          deregisterWatchCurrentTenant();
        }
      });

    });

})();
